

const ProtocolInfo = ({ coin }) => {


  return (
    <div className="account-card flex flex-col flex-1 items-start mb-2">
      <h4 className="font-semibold text-gray-700 text-18 mb-3">{coin} Protocol Rules</h4>
      <p className="m-0 whitespace-pre-line text-16">
        When sending or receiving {coin} on the main chain, the primary awareness points for a customer involve
        transaction irreversibility, address accuracy, and variable fees and confirmation times. Failing to adhere to these can lead to permanent fund loss or significant recovery hurdles.


        {coin.includes('XRP') && <p className="m-0 whitespace-pre-line pt-2"> <span className=" fw-semibold">Minimum Balance:</span> <br /> All new XRP Ledger accounts must lock a permanent minimum balance of 1 XRP to be activated. This amount is not a fee but a reserve that cannot be spent.
          Owner Reserve: In addition to the base reserve, there is an owner reserve of 1 XRP for each object associated with the account.
          Implication: Ensure your account is funded with enough XRP to cover the reserve before attempting other transactions.</p>}

      </p>
    </div>
  );
};

export default ProtocolInfo;
